export enum FilterSearchParam {
  SchoolYear = 'schoolYear',
  School = 'school',
  Groups = 'groups',
  Module = 'module',
  Members = 'members',
  Exercises = 'exercises',
}
